export interface WidgetDefinition {
  id: string
  name: string
  description: string
  icon: string // lucide icon name
  category:
    | 'kpis'
    | 'github'
    | 'sprint'
    | 'team'
    | 'activity'
    | 'productivity'
    | 'calendar'
  cols: 1 | 2 | 3 | 4 // grid column span
  isNew?: boolean // shows NEW badge in catalog
  addedDate?: string // ISO date for tracking new widgets
}
export const widgetRegistry: WidgetDefinition[] = [
  {
    id: 'global-kpis',
    name: 'KPIs Globales',
    description: 'Resumen de proyectos activos, equipo y velocidad.',
    icon: 'BarChart2',
    category: 'kpis',
    cols: 4,
  },
  {
    id: 'github-activity',
    name: 'GitHub Activity',
    description: 'Métricas de PRs, commits y actions en la organización.',
    icon: 'Github',
    category: 'github',
    cols: 4,
  },
  {
    id: 'project-cards',
    name: 'Proyectos',
    description: 'Lista filtrable de tarjetas de proyectos con su estado.',
    icon: 'LayoutGrid',
    category: 'kpis',
    cols: 4,
  },
  {
    id: 'cross-project-summary',
    name: 'Resumen Cross-Project',
    description: 'Tarjetas de resumen de issues y bloqueadores globales.',
    icon: 'Layers',
    category: 'kpis',
    cols: 4,
  },
  {
    id: 'sprint-burndown',
    name: 'Sprint Burndown',
    description: 'Gráfico de burndown del sprint actual.',
    icon: 'TrendingDown',
    category: 'sprint',
    cols: 2,
    isNew: true,
  },
  {
    id: 'sprint-health',
    name: 'Sprint Health',
    description: 'Medidor de salud y métricas del sprint.',
    icon: 'Activity',
    category: 'sprint',
    cols: 2,
    isNew: true,
  },
  {
    id: 'activity-feed',
    name: 'Activity Feed',
    description: 'Feed de actividad en tiempo real.',
    icon: 'List',
    category: 'activity',
    cols: 2,
    isNew: true,
  },
  {
    id: 'blockers-list',
    name: 'Bloqueadores',
    description: 'Lista de bloqueadores activos en todos los proyectos.',
    icon: 'AlertTriangle',
    category: 'team',
    cols: 2,
    isNew: true,
  },
  {
    id: 'team-workload',
    name: 'Carga del Equipo',
    description: 'Distribución de carga de trabajo del equipo.',
    icon: 'Users',
    category: 'team',
    cols: 2,
    isNew: true,
  },
  {
    id: 'todo-list',
    name: 'TODO List',
    description: 'Lista de tareas personal con colores, prioridades y links.',
    icon: 'ListTodo',
    category: 'productivity',
    cols: 2,
    isNew: true,
  },
  {
    id: 'personal-notes',
    name: 'Notas Personales',
    description: 'Notas rápidas tipo sticky notes con colores.',
    icon: 'StickyNote',
    category: 'productivity',
    cols: 2,
    isNew: true,
  },
  {
    id: 'calendar',
    name: 'Calendario',
    description: 'Vista mensual con eventos de Jira, GitHub y más.',
    icon: 'CalendarDays',
    category: 'calendar',
    cols: 2,
    isNew: true,
  },
  {
    id: 'reminders',
    name: 'Recordatorios',
    description: 'Reminders con snooze, dismiss y recurrencia.',
    icon: 'Bell',
    category: 'calendar',
    cols: 2,
    isNew: true,
  },
]
export const DEFAULT_LAYOUT = [
  'global-kpis',
  'todo-list',
  'calendar',
  'personal-notes',
  'reminders',
  'github-activity',
  'project-cards',
]
export function getWidgetById(id: string): WidgetDefinition | undefined {
  return widgetRegistry.find((w) => w.id === id)
}
export function getWidgetsByCategory(
  category: WidgetDefinition['category'],
): WidgetDefinition[] {
  return widgetRegistry.filter((w) => w.category === category)
}
